import { createListenerMiddleware, isAnyOf, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { RootState } from '@/store'
import { adminStoreActions, storeActions, ThunkExtra } from '@/store/actions'
import { getBeneficiariesStructuredDataState } from '@/store/structured-data-state/thunks'

let structuredDataPollingInterval: NodeJS.Timeout | null = null
const STRUCTURED_DATA_POLLING_INTERVAL = 3000 // 3 seconds

const instance = createListenerMiddleware<
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>()

instance.startListening({
  actionCreator: adminStoreActions.initAdmin.fulfilled,
  effect: (_, listenerApi) => {
    listenerApi.cancelActiveListeners()

    if (structuredDataPollingInterval) {
      clearInterval(structuredDataPollingInterval)
    }

    structuredDataPollingInterval = setInterval(() => {
      listenerApi.dispatch(getBeneficiariesStructuredDataState() as unknown as UnknownAction)
    }, STRUCTURED_DATA_POLLING_INTERVAL)

    listenerApi.dispatch(getBeneficiariesStructuredDataState() as unknown as UnknownAction)
  },
})

instance.startListening({
  matcher: isAnyOf(
    storeActions.cleanUpOrganization,
    storeActions.initDashboard,
    storeActions.beneficiary.initBeneficiary.fulfilled,
  ),
  effect: (_, listenerApi) => {
    listenerApi.cancelActiveListeners()

    if (structuredDataPollingInterval) {
      clearInterval(structuredDataPollingInterval)
      structuredDataPollingInterval = null
    }
  },
})

export const structuredDataStateMiddleware = instance.middleware
